module.exports = __webpack_public_path__ + "img/face63.1c92381f.gif";